import { render, staticRenderFns } from "./BenefitSection.vue?vue&type=template&id=68c2347a&scoped=true"
import script from "./BenefitSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./BenefitSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BenefitSection.vue?vue&type=style&index=0&id=68c2347a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c2347a",
  null
  
)

export default component.exports